import { render, staticRenderFns } from "./Video-1.vue?vue&type=template&id=2e8d9b99&scoped=true"
import script from "./Video-1.vue?vue&type=script&lang=js"
export * from "./Video-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d9b99",
  null
  
)

export default component.exports